import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";

const Navbar = () => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  // console.log(user);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileMenu = (event) => {
    setProfileAnchorEl(event.currentTarget);
  };

  const handleProfileClose = () => {
    setProfileAnchorEl(null);
  };

  return (
    <AppBar position="sticky">
      <Toolbar>
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <img
            src="https://seethakalyanavaibhogame.com/images/mainlogo.jpg"
            alt="Logo"
            style={{
              height: "50px",
              width: "50px",
              marginRight: "15px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{ color: "white", textDecoration: "none", fontWeight: 700 }}
          >
            Seetha Kalyana Vaibhogame
          </Typography>
        </Box>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            gap: 2,
            alignItems: "center",
          }}
        >
          {!user && (
            <Button color="inherit" component={Link} to="/">
              Home
            </Button>
          )}
          {/* <Button color="inherit" component={Link} to="/register-page">
            Home01
          </Button> */}
          {/* <Button color="inherit" component={Link} to="/demo-dashboard">
            Demo Dashboard
          </Button> */}
          {user && user.user_type === 1 && (
            <Button color="inherit" component={Link} to="/guestDashboard">
              Guest Dashboard
            </Button>
          )}
          
          {user && user.user_type !== 1 && (
            <Button color="inherit" component={Link} to="/dashboard">
              Dashboard
            </Button>
          )}
          {user && user.user_type !== 1 && (
            <Button color="inherit" component={Link} to="/guest-search">
              Profiles Search
            </Button>
          )}
          {/* {user && ( */}
          <Button color="inherit" component={Link} to="/purchase">
            Purchase
          </Button>
          {/* )} */}
          {/* <Button color="inherit" component={Link} to="/contact">Contact Us</Button> */}
          {!user && (
            // <Button color="inherit" component={Link} to="/login">
            //   Login
            // </Button>
            <Button color="inherit" component={Link} to="/login-page">
              Login
            </Button>
          )}
          {!user && (
            // <Button color="inherit" component={Link} to="/register">
            //   Register
            // </Button>
            <Button color="inherit" component={Link} to="/register-page">
            Register
          </Button>
          )}
          {/* {!user && (
            <Button color="inherit" component={Link} to="/guest-register">
              Guest User
            </Button>
          )} */}

          {/* Profile Icon for authenticated users */}
          {user && (
            <IconButton
              color="inherit"
              onClick={handleProfileMenu}
              sx={{
                ml: 1,
                color: "white !important",
                "&:hover": {
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <AccountCircleIcon />
            </IconButton>
          )}
        </Box>

        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <IconButton 
            onClick={handleMenu}
            sx={{
              color: "white !important",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                color: "white !important",
              },
              border: "1px solid rgba(255, 255, 255, 0.3)",
              borderRadius: "8px",
              padding: "8px",
            }}
          >
            <MenuIcon sx={{ fontSize: "1.5rem" }} />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              sx: {
                bgcolor: "white",
                color: "text.primary",
                minWidth: 200,
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                "& .MuiMenuItem-root": {
                  color: "#333",
                  fontWeight: 500,
                  "&:hover": {
                    bgcolor: "primary.main",
                    color: "white",
                  },
                },
              },
            }}
          >

        {!user && (
            <MenuItem 
              component={Link} 
              to="/" 
              onClick={handleClose}
              sx={{ 
                color: "#333 !important", 
                fontWeight: 500,
                "&:hover": { 
                  bgcolor: "primary.main !important", 
                  color: "white !important" 
                }
              }}
            >
              Home
            </MenuItem>
        )}
            {user && user.user_type === 1 && (
              <MenuItem 
                component={Link} 
                to="/guestDashboard" 
                onClick={handleClose}
                sx={{ 
                  color: "#333 !important", 
                  fontWeight: 500,
                  "&:hover": { 
                    bgcolor: "primary.main !important", 
                    color: "white !important" 
                  }
                }}
              >
                Guest Dashboard
              </MenuItem>
            )}
            {user && user.user_type !== 1 && (
              <MenuItem 
                component={Link} 
                to="/dashboard" 
                onClick={handleClose}
                sx={{ 
                  color: "#333 !important", 
                  fontWeight: 500,
                  "&:hover": { 
                    bgcolor: "primary.main !important", 
                    color: "white !important" 
                  }
                }}
              >
                Dashboard
              </MenuItem>
            )}
            {user && (
              <MenuItem 
                component={Link} 
                to="/profile" 
                onClick={handleClose}
                sx={{ 
                  color: "#333 !important", 
                  fontWeight: 500,
                  "&:hover": { 
                    bgcolor: "primary.main !important", 
                    color: "white !important" 
                  }
                }}
              >
                Profile
              </MenuItem>
            )}
            {user && user.user_type !== 1 && (
              <MenuItem
                component={Link}
                to="/guest-search"
                onClick={handleClose}
                sx={{ 
                  color: "#333 !important", 
                  fontWeight: 500,
                  "&:hover": { 
                    bgcolor: "primary.main !important", 
                    color: "white !important" 
                  }
                }}
              >
                Profiles Search
              </MenuItem>
            )}
            <MenuItem 
              component={Link} 
              to="/purchase" 
              onClick={handleClose}
              sx={{ 
                color: "#333 !important", 
                fontWeight: 500,
                "&:hover": { 
                  bgcolor: "primary.main !important", 
                  color: "white !important" 
                }
              }}
            >
              Purchase
            </MenuItem>

            {!user && (
              <MenuItem 
                component={Link} 
                to="/login-page" 
                onClick={handleClose}
                sx={{ 
                  color: "#333 !important", 
                  fontWeight: 500,
                  "&:hover": { 
                    bgcolor: "primary.main !important", 
                    color: "white !important" 
                  }
                }}
              >
                Login
              </MenuItem>
            )}
            {!user && (
              <MenuItem 
                component={Link} 
                to="/register-page" 
                onClick={handleClose}
                sx={{ 
                  color: "#333 !important", 
                  fontWeight: 500,
                  "&:hover": { 
                    bgcolor: "primary.main !important", 
                    color: "white !important" 
                  }
                }}
              >
                Register
              </MenuItem>
            )}

            {user && (
              <MenuItem
                onClick={() => {
                  logout();
                  handleClose();
                }}
                sx={{ 
                  color: "#333 !important", 
                  fontWeight: 500,
                  "&:hover": { 
                    bgcolor: "error.main !important", 
                    color: "white !important" 
                  }
                }}
              >
                Logout
              </MenuItem>
            )}
          </Menu>
        </Box>

        {/* Profile Dropdown Menu */}
        <Menu
          anchorEl={profileAnchorEl}
          open={Boolean(profileAnchorEl)}
          onClose={handleProfileClose}
          PaperProps={{
            sx: {
              bgcolor: "background.paper",
              color: "text.primary",
              mt: 1,
              minWidth: 150,
            },
          }}
        >
          <MenuItem
            component={Link}
            to="/profile"
            onClick={handleProfileClose}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              "&:hover": {
                bgcolor: "primary.main",
                color: "primary.contrastText",
              },
            }}
          >
            <AccountCircleIcon fontSize="small" />
            Profile
          </MenuItem>
          <MenuItem
            onClick={() => {
              logout();
              handleProfileClose();
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              "&:hover": {
                bgcolor: "error.main",
                color: "error.contrastText",
              },
            }}
          >
            <LogoutIcon fontSize="small" />
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
